module.exports = __webpack_public_path__ + "img/img-f34670.png";